"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.SuggestionsContextMenu = void 0;

var _slice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/slice"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/for-each"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/filter"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/map"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/concat"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));

var _parseInt2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/parse-int"));

var _jsxRuntime = require("react/jsx-runtime");

var _react = require("@fluentui/react");

var _ContextualMenu = require("@fluentui/react/lib/ContextualMenu");

var _Icon = require("@fluentui/react/lib/Icon");

var _Persona = require("@fluentui/react/lib/Persona");

var React = _interopRequireWildcard(require("react"));

var _highlightDisplayText = _interopRequireWildcard(require("./highlightDisplayText"));

var _Suggestion = require("./Suggestion");

/* Ported from https://outlookweb.visualstudio.com/Outlook%20Web */
var searchBoxStyles = require('./SearchBox.scoped.scss');

var styles = require('./SuggestionsContextMenu.scoped.scss');

var PERSONA_PILL_LIMIT = process.env.APP_PERSONA_PILL_LIMIT ? (0, _parseInt2.default)(process.env.APP_PERSONA_PILL_LIMIT, 10) : 5;
var MAX_SUGGESTIONS_TO_SHOW = process.env.APP_MAX_SUGGESTIONS_TO_SHOW ? (0, _parseInt2.default)(process.env.APP_MAX_SUGGESTIONS_TO_SHOW, 10) : 10;

var SuggestionsContextMenu = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(SuggestionsContextMenu, _React$Component);

  var _super = (0, _createSuper2.default)(SuggestionsContextMenu);

  function SuggestionsContextMenu() {
    var _context;

    var _this;

    (0, _classCallCheck2.default)(this, SuggestionsContextMenu);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, (0, _concat.default)(_context = [this]).call(_context, args));
    _this.suggestions = [];

    _this._createPinnedItem = function (query) {
      return {
        key: query,
        name: query,
        className: styles.keywordSuggestion,
        onRender: function onRender() {
          var onTextSuggestionClick = function onTextSuggestionClick() {
            _this.props.onTextSuggestionClick(query);
          };

          var onUnpinSearchClicked = function onUnpinSearchClicked() {
            var _this$props$onUnpinSe, _this$props;

            return (_this$props$onUnpinSe = (_this$props = _this.props).onUnpinSearchClicked) === null || _this$props$onUnpinSe === void 0 ? void 0 : _this$props$onUnpinSe.call(_this$props, query, 'SearchBoxSuggestionDropDown');
          };

          return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: styles.pinnedItem,
            tabIndex: 0,
            children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
              tabIndex: 0,
              className: styles.pinnedKeyword,
              title: query,
              "data-click-source": 'search_box',
              onMouseDown: onTextSuggestionClick,
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
                className: searchBoxStyles.suggestionHistoryClockIcon,
                iconName: 'Pinned'
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                className: styles.keywordNonMatchSuggestion,
                children: query
              })]
            }, query), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              tabIndex: 0,
              "data-click-source": 'search_box' // used to identify the source of the click in suggestion dropdown
              ,
              onClick: onUnpinSearchClicked,
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
                className: (0, _react.css)(searchBoxStyles.pinIcon, styles.pinActionIconContainer),
                iconName: 'Pinned',
                title: 'Unpin Search'
              })
            })]
          });
        }
      };
    };

    _this._createKeywordSuggestionItem = function (_traceId, suggestion, index) {
      var highlightTextRegions = (0, _highlightDisplayText.default)(suggestion.displayText);

      var onTextSuggestionClick = function onTextSuggestionClick() {
        _this.props.onTextSuggestionClick(suggestion.queryText);
      };

      return {
        key: suggestion.displayText,
        name: suggestion.displayText,
        className: _this.props.selectedSuggestionIndex === index ? styles.suggestionSelected : '',
        onRender: function onRender() {
          var _context2;

          return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            tabIndex: 0,
            className: styles.keywordSuggestion,
            "data-click-source": 'search_box' // VSO:17221 as a part of 17221, we should change onMouseDown to onClick
            ,
            onMouseDown: onTextSuggestionClick,
            title: (0, _highlightDisplayText.dehighlightDisplayText)(suggestion.displayText),
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
              className: searchBoxStyles.suggestionHistoryClockIcon,
              iconName: 'Clock'
            }), (0, _map.default)(_context2 = (0, _filter.default)(highlightTextRegions).call(highlightTextRegions, function (e) {
              return e.text.length > 0;
            })).call(_context2, function (e, i) {
              var className = e.isHighlighted ? styles.keywordMatchSuggestion : styles.keywordNonMatchSuggestion;
              return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                className: className,
                children: e.text
              }, i);
            })]
          }, suggestion.displayText);
        }
      };
    };

    _this._createPeopleSuggestionItem = function (_traceId, suggestion, index) {
      var onPeopleSuggestionClick = function onPeopleSuggestionClick() {
        if (_this.props.onPeopleSuggestionClick !== undefined) {
          _this.props.onPeopleSuggestionClick(suggestion);
        }
      };

      return {
        key: suggestion.objectId,
        name: suggestion.primaryText,
        className: _this.props.selectedSuggestionIndex === index ? styles.suggestionSelected : '',
        onRender: function onRender() {
          return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            tabIndex: 0,
            className: styles.personaSuggestion,
            "data-click-source": 'search_box',
            onClick: onPeopleSuggestionClick,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Persona.Persona, {
              text: suggestion.primaryText,
              secondaryText: suggestion.secondaryText,
              size: _Persona.PersonaSize.extraExtraSmall
            })
          }, suggestion.objectId);
        }
      };
    };

    return _this;
  }

  (0, _createClass2.default)(SuggestionsContextMenu, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ContextualMenu.ContextualMenu, {
        useTargetWidth: true,
        shouldFocusOnMount: false,
        target: this.props.targetElement,
        gapSpace: 2 // we need a 2 px gap between the suggestions menu and the box when search is in header
        ,
        directionalHintFixed: true // ensure the position will not change sides in an attempt to fit the callout within bounds.
        ,
        directionalHint: _ContextualMenu.DirectionalHint.bottomLeftEdge,
        items: this.searchMenuItems
      });
    }
  }, {
    key: "searchMenuItems",
    get: function get() {
      var _this2 = this;

      var items = this.suggestions;
      var suggestionSet = this.props.suggestionsSet;

      if (suggestionSet && suggestionSet.isComplete) {
        var _context3, _context4;

        items = [];
        var savedSearches = this.props.getSavedSearches && this.props.getSavedSearches() || [];

        if (this.props.shouldShowPinSearchIcon && savedSearches) {
          // first render the pinned items
          (0, _forEach.default)(savedSearches).call(savedSearches, function (query) {
            items.push(_this2._createPinnedItem(query));
          });
          items.push({
            key: 'divider_1',
            itemType: _ContextualMenu.ContextualMenuItemType.Divider
          });
        } // Show people suggestions only when we have not already selected 2 persona suggestions


        var shouldShowPeopleSuggestions = this.props.personaPills === undefined || this.props.personaPills.length < PERSONA_PILL_LIMIT;
        (0, _map.default)(_context3 = (0, _slice.default)(_context4 = suggestionSet.suggestions).call(_context4, 0, MAX_SUGGESTIONS_TO_SHOW)).call(_context3, function (suggestion, index) {
          if (suggestion.kind === _Suggestion.SuggestionKind.persona && shouldShowPeopleSuggestions) {
            var _suggestionSet$traceI;

            items.push(_this2._createPeopleSuggestionItem((_suggestionSet$traceI = suggestionSet.traceId) !== null && _suggestionSet$traceI !== void 0 ? _suggestionSet$traceI : 0, suggestion, index));
          } else if (suggestion.kind === _Suggestion.SuggestionKind.keywords) {
            var _suggestionSet$traceI2;

            items.push(_this2._createKeywordSuggestionItem((_suggestionSet$traceI2 = suggestionSet.traceId) !== null && _suggestionSet$traceI2 !== void 0 ? _suggestionSet$traceI2 : 0, suggestion, index));
          }
        });
      }

      return this.suggestions = items;
    }
  }]);
  return SuggestionsContextMenu;
}(React.Component);

exports.SuggestionsContextMenu = SuggestionsContextMenu;